import {
    Button,
    createStyles,
    makeStyles,
    Theme,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@material-ui/core";
import styles from "./PuiDialog.module.css";
import React from "react";

interface PuiDialogProps {
    openDialog: boolean;
    title: string;
    message: string;
    yesLabel: string;
    noLabel: string;
    handleCloseDialog: () => void;
    handleCancel: () => void;
    handleConfirm: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialog: {
            "& .MuiDialog-paper": {
                backgroundColor: "var(--modal-bg)",
                width: "560px",
                height: "214px",
            },
        },
        dialogTitle: {
            padding: "40px 24px 5px 10px",
            color: "var(--white)",
            "& .MuiTypography-h6": {
                fontSize: "18px",
                fontFamily: "noto-sans-cjk-jp",
                color: "white",
            },
        },
        dialogContent: {
            "& .MuiDialogContentText-root": {
                fontFamily: "noto-sans-cjk-jp",
                color: "var(--gray-80)",
                textAlign: "center",
            },
        },
        dialogActions: {
            marginBottom: "30px",
            marginRight: "55px",
            display: "flex",
            textAlign: "center",
        },
    })
);

function PuiDialog({
    openDialog,
    title,
    message,
    yesLabel,
    noLabel,
    handleCloseDialog,
    handleCancel,
    handleConfirm,
}: PuiDialogProps) {
    const classes = useStyles();

    return (
        <Dialog
            className={classes.dialog}
            disableEscapeKeyDown
            fullWidth={false}
            maxWidth="md"
            open={openDialog}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    handleCloseDialog();
                }
            }}
        >
            <div className={styles.dialogTitle}>
                <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">
                    {title}
                </DialogTitle>
            </div>
            <DialogContent className={classes.dialogContent}>
                <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    size="medium"
                    variant="outlined"
                    type="submit"
                    color="secondary"
                    onClick={handleCancel}
                    style={{
                        marginRight: "10px",
                        color: "#9C9C9C",
                        width: "200px",
                        height: "40px",
                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                        border: "solid 2px #5D5D5D",
                    }}
                >
                    {noLabel}
                </Button>
                <Button
                    size="medium"
                    variant="contained"
                    type="submit"
                    color="secondary"
                    style={{
                        color: "white",
                        width: "200px",
                        height: "40px",
                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                        backgroundColor: "var(--studio-btn-bg)",
                    }}
                    onClick={handleConfirm}
                    autoFocus
                >
                    {yesLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PuiDialog;
